module.exports = __webpack_public_path__ + "static/media/exclamation-mark.6456e73d.svg";